module.exports = __webpack_public_path__ + "static/media/icon_add_patient.6a470a9f.svg";